/**
 * 管理制度
*/
import http from '@/request/http'
export default {
  /******   规章制度   *****/
  // 获取规章制度/运营要求
  systemGetList: params => http.get(`/api/juji/project/rules/get`, params),
  systemOnlinePreview: (params, file_id) => http.get(`/api/juji/filesvc/local/view/${file_id}`, params),

}

